import { render, staticRenderFns } from "./tab-area.vue?vue&type=template&id=18ad7e5e&scoped=true&"
import script from "./tab-area.vue?vue&type=script&lang=ts&"
export * from "./tab-area.vue?vue&type=script&lang=ts&"
import style0 from "./tab-area.vue?vue&type=style&index=0&id=18ad7e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad7e5e",
  null
  
)

export default component.exports